/** Role-aware placement route helpers — preparation namespace (Phase 1B). */

export function getPlacementRoot(user) {
  const role = user?.role;
  if (role === 'admin') return '/admin/placement';
  if (role === 'faculty' || role === 'cbcfaculty') return '/faculty/placement';
  if (role === 'student') return '/student/placement';
  return '/student/placement';
}

const PREP = 'preparation';

export function placementOverviewPath(user) {
  return `${getPlacementRoot(user)}/overview`;
}

export function placementCampaignsPath(user) {
  return `${getPlacementRoot(user)}/${PREP}/campaigns`;
}

export function placementCampaignPath(user, campaignId) {
  return `${placementCampaignsPath(user)}/${campaignId}`;
}

export function placementCampaignCapturePath(user, campaignId) {
  return `${placementCampaignPath(user, campaignId)}/capture`;
}

export function placementInterviewsPath(user) {
  return `${getPlacementRoot(user)}/${PREP}/interviews`;
}

export function placementInterviewPath(user, sessionId) {
  return `${placementInterviewsPath(user)}/${sessionId}`;
}

export function placementStudentsPath(user) {
  return `${getPlacementRoot(user)}/${PREP}/students`;
}

export function placementCoachingInsightsPath(user) {
  return `${getPlacementRoot(user)}/${PREP}/insights`;
}

/** @deprecated Use placementCoachingInsightsPath */
export function placementReportsPath(user) {
  return placementCoachingInsightsPath(user);
}

export function studentPlacementHubPath() {
  return '/student/placement';
}

export function studentPlacementCompaniesPath() {
  return '/student/placement/companies';
}

export function studentPlacementCompanyPath(companyId) {
  return `/student/placement/company/${companyId}`;
}

export function studentPlacementProfilePath() {
  return '/student/placement/profile';
}

export function studentMockInterviewsPath() {
  return '/student/placement/preparation/interviews';
}

export function studentCareerSignalsPath() {
  return '/student/placement/preparation/insights';
}

export function facultyBatchPlacementReadinessPath(user, batchId) {
  const root = user?.role === 'admin' ? '/admin' : '/faculty';
  return `${root}/placement/batches/${batchId}/readiness`;
}

/** Faculty Preparation Workspace — company intelligence prep campaigns (not mock interviews). */
export function facultyPreparationWorkspacePath(user) {
  const root = user?.role === 'admin' ? '/admin' : '/faculty';
  return `${root}/placement/preparation`;
}

/** Stable preparation campaign route (company intelligence — supports multiple per company×batch). */
export function facultyPreparationCampaignPath(user, campaignId) {
  const root = user?.role === 'admin' ? '/admin' : '/faculty';
  return `${root}/placement/journey/campaign/${campaignId}`;
}

/** @deprecated Redirect target — use facultyPreparationWorkspacePath */
export function facultyJourneyTodayPath(user) {
  return facultyPreparationWorkspacePath(user);
}

export function facultyJourneyBatchPath(user, batchId, companyId) {
  const root = user?.role === 'admin' ? '/admin' : '/faculty';
  const base = `${root}/placement/journey/batch/${batchId}`;
  return companyId ? `${base}?companyId=${companyId}` : base;
}

export function facultyJourneyMonitorPath(user, batchId, assignmentId) {
  const root = user?.role === 'admin' ? '/admin' : '/faculty';
  return `${root}/placement/journey/batch/${batchId}/assignment/${assignmentId}/monitor`;
}

/** Phase 7 company intelligence console (admin + cbcfaculty). */
export function companyIntelligenceConsolePath(user) {
  const root = user?.role === 'admin' ? '/admin' : '/faculty';
  return `${root}/company-intelligence`;
}

export function studentFeedbackPath() {
  return '/student/placement/preparation/interviews';
}
